<template>
  <v-container
    class="customer-mini-card"
    :class="{ mini, 'pa-0': noPadding, styled }"
  >
    <template v-if="value && Object.keys(value).length > 0 && (typeof value.id !== 'undefined' && value.id >= 0)">
      <v-row class="customer-mini-card-title px-0 mx-0">
        <v-col cols="11" class="name-col">{{ `${(!hideId ? '#' + value.id + '  ' : '')}${value.name}` }}</v-col>
        <v-col cols="1">
          <v-btn
            @click.stop="$router.push({ name: 'customers:view', params: { id: value.id }})"
            color="primary"
            icon
            x-small
          >
            <v-icon small>mdi-open-in-new</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-row class="customer-mini-card-subtitle px-0 mx-0">
        <v-col :cols="(mini ? 12 : 6)">
          <div class="phone">
            <v-icon
              small
              color="blue"
            >
              mdi-phone
            </v-icon>
            {{ value.phone | phoneMask }}
          </div>
        </v-col>
        <v-col
          v-if="!hideCpf && value.identity !== ''"
          :cols="(mini ? 12 : 6)"
        >
          <div class="identity">
            <v-icon
              small
              color="green"
            >
              mdi-card-bulleted
            </v-icon>
            {{ value.identity | cpfMask }}
          </div>
        </v-col>
      </v-row>
    </template>
    <template v-else>
      <v-row class="customer-mini-card-title px-0 mx-2">
        <v-col cols="12" class="name-col my-2">
          {{ `${lang.customers.widget.noneCustomer} (${noneRef})` }}
        </v-col>
      </v-row>
    </template>
  </v-container>
</template>

<script>
import appdata from '@/mixins/appdata'

export default {
  mixins: [ appdata ],
  props: {
    value: {
      type: Object,
      required: true
    },
    noneRef: {
      type: String,
      default: ''
    },
    hideId: {
      type: Boolean,
      default: false
    },
    mini: {
      type: Boolean,
      default: false
    },
    hideCpf: {
      type: Boolean,
      default: false
    },
    noPadding: {
      type: Boolean,
      default: false
    },
    styled: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
.customer-mini-card {
  $root: &;
  #app & {
    min-width: 234px !important;
    width: 100%;
    margin: 4px 0px;
    padding: 7px;
    border-radius: 3px;
    &.mini {
      min-width: 134px !important;
      max-width: 100% !important;
      margin: 0px !important;
      #{$root}-title, #{$root}-subtitle {
        .col {
          padding: 0px !important;
        }
      }
    }
    &-title {
      font-size: 13.5px !important;
      margin: 0px !important;
      .name-col {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    &-subtitle {
      font-size: 12px !important;
      margin: 0px !important;
      .phone {
        float: left;
      }
      .identity {
        float: left;
      }
    }
    .col {
      padding: 0px 4px 1px 4px !important;
    }
    &.styled {
      padding: 5px !important;
      border-radius: 5px;
    }
  }
  #app.theme--light & {
    background: linear-gradient(325deg,
      rgba(255,255,255,0.07) 0%,
      rgba(255,255,255,0.12) 30%,
      rgba(255,255,255,0.12) 50%,
      rgba(255,255,255,0.12) 70%,
      rgba(255,255,255,0.07) 100%
    );
    &:hover {
      background: rgba(255,255,255,0.15) !important;
    }
    &.styled {
      background: rgba(0,0,0,0.01) !important;
      border-left: 5px solid #f2f2f2;
    }
  }
  #app.theme--dark & {
    background: linear-gradient(325deg,
      rgba(0,0,0,0.07) 0%,
      rgba(0,0,0,0.2) 30%,
      rgba(0,0,0,0.2) 50%,
      rgba(0,0,0,0.2) 70%,
      rgba(0,0,0,0.07) 100%
    );
    &:hover {
      background: rgba(0,0,0,0.15) !important;
    }
  }
}
</style>
